import { validationMixin } from 'vuelidate'
  import {
    required,
    email,
  } from 'vuelidate/lib/validators'


import locationComponent from './locationComponent.vue';
export default {
  props: ['ajax_url'],
  
  name: 'clientFormComponent',
  mixins: [validationMixin],
  components: {
    locationComponent
  },


  data: function () {
    return{
      response:false,
      submitting:false,
      form:{
        lead:'Lead',
        company:null,
        address:null,
        cross_street:null,
        hear:null,
        city:null,
        state:'AZ',
        zip:null,
        phone:null,
        name:null,
        mobile:null,
        email:null,
        same_location:false,
        locations:[
          {
            treatment_location_site:null,
            treatment_location_address:null,
            treatment_location_city:null,
            treatment_location_state:'AZ',
            treatment_location_zip:null,
            treatment_location_phone:null,
            treatment_location_site_cross:null,
            treatment_location_onsite_contact:null,
            treatment_location_onsite_mobile:null,
            treatment_sqfeet:null,

            treatment_quote:null,

            treatment_details_sqfeet:null,
            treatment_details_type:null,
            treatment_details_day:null,
            treatment_details_window:null,
            treatment_details_numbers:null,

            
          }


        ],
        
        salesperson:null,
        notes:null,
      }
    }
  },

  validations: {

    form: {
      company:{required},
      address:{required},
      cross_street:{required},
      hear:{required},
      city:{required},
      state:{required},
      zip:{required},
      phone:{required},
      name:{},
      mobile:{},
      email:{required,email},
      salesperson:{required,email},
     
    }

  },
  

  created: function () {
  },

  methods:{

    form_changed(index,form){
      this.form.locations[index] = form;
      console.log(this.form.locations);
    },

    remove_location(index){
      this.form.locations.splice(index, 1);
    },

    validateForm(){
      this.$v.form.$touch();

      let check_locations = 0;
      this.$refs.locations.forEach(function(component) {
        let validate = component.validateForm();
        if(validate){
          check_locations++;
        }
        console.log(check_locations)
      });

      if (!this.$v.form.$invalid) {

          if(!this.form.same_location){
            if(check_locations == this.form.locations.length){
              this.submit_form();
            }else{
              console.log('Invalid')
            }
          }else{
            this.submit_form();
          }
          
      }else{
          console.log('Invalid')
      }
    },

    submit_form(){

      

      this.submitting = true;
      this.$http.post(this.ajax_url+'?action=client_submit_form', {
        form : this.form,
      }).then((response) => {
       
        if(response.data.error){
          this.submitting = false;
        }else{
          this.response = response.data.message;
          window.scrollTo(0,0);
        }
        
       
       
       
      }).catch(error => {
        console.log(error.message)
      });
    },



    add_location(){
      let location = {
        treatment_location_site:null,
        treatment_location_address:null,
        treatment_location_city:null,
        treatment_location_state:'AZ',
        treatment_location_zip:null,
        treatment_location_phone:null,
        treatment_location_site_cross:null,
        treatment_location_onsite_contact:null,
        treatment_location_onsite_mobile:null,
        treatment_sqfeet:null,
        treatment_quote:null,

        treatment_details_sqfeet:null,
        treatment_details_type:null,
        treatment_details_day:null,
        treatment_details_window:null,
        treatment_details_numbers:null,
        
      }
      this.form.locations.push(location);
    }

  },

  watch: {
  }

}